import React from 'react';
import ConnectGithub from 'images/screenshots/github-connect.svg';
import ConnectGitLab from 'images/screenshots/gitlab-connect.svg';
import ConnectBitbucket from 'images/screenshots/bitbucket-connect.svg';
import GitTypes from 'common/constants/GitTypes';
import { Flex } from 'components/base/layout-components';
import GitHubExplanation from './GitHubExplanation';
import { InfoInstructionsBox, StyledDash, StyledDot } from './components';
import Text from 'components/base/Text';
import styled from 'styled-components';

const PROVIDER_TO_IMAGE = {
  [GitTypes.GITHUB]: {
    src: ConnectGithub,
    width: '33.6rem',
    height: '53.8rem'
  },
  [GitTypes.GITLAB]: {
    src: ConnectGitLab,
    width: '29.7rem',
    height: '33.2rem',
    margin: '7rem 0 0 10rem'
  },
  [GitTypes.BITBUCKET]: {
    src: ConnectBitbucket,
    width: '38.6rem',
    height: '26.4rem',
    margin: '9rem 0 0 11.5rem'
  },
  [GitTypes.AZURE_DEVOPS]: null
};
const PROVIDER_TO_EXPLANATION = {
  [GitTypes.GITHUB]: <GitHubExplanation />,
  [GitTypes.GITLAB]: (
    <Flex ml='1rem' width='16rem' mt='28.2rem'>
      <InfoInstructionsBox width='fit-content'>
        <Text size='normal' lineHeight='1.45rem' weight='700' mt='0.2rem'>
          Make sure to authorise
        </Text>
        <StyledDash width='3.2rem' left='-3.2rem' bottom='50%'>
          <StyledDot right='-0.3rem' top='-0.3rem' />
          <StyledDot left='-0.3rem' top='-0.3rem' />
        </StyledDash>
      </InfoInstructionsBox>
    </Flex>
  ),
  [GitTypes.BITBUCKET]: (
    <Flex ml='-11.6rem' width='16rem' mt='28.2rem'>
      <InfoInstructionsBox width='fit-content'>
        <Text size='normal' lineHeight='1.45rem' weight='700' mt='0.2rem'>
          Make sure to authorise
        </Text>
        <StyledDash height='4.5rem' left='1.2rem' top='-4.5rem'>
          <StyledDot left='-0.3rem' top='-0.3rem' />
          <StyledDot left='-0.3rem' bottom='-0.3rem' />
        </StyledDash>
      </InfoInstructionsBox>
    </Flex>
  )
};

const StyledImageWrapper = styled(Flex)`
  box-shadow: 0 0 34px 0 rgba(59, 89, 152, 0.2);
`;

const StyledImage = styled.img`
  height: 100%;
  width: auto;
  max-width: 100%;
`;

const OAuthGitProviderInstructions = ({ provider }) => {
  const { width, height, margin, src } = PROVIDER_TO_IMAGE[provider] || {};
  return (
    <Flex height='100%'>
      <StyledImageWrapper
        width={width}
        height={height}
        margin={margin}
        position='relative'
      >
        <StyledImage src={src} alt={provider} />
        {PROVIDER_TO_EXPLANATION[provider]}
      </StyledImageWrapper>
    </Flex>
  );
};

export default OAuthGitProviderInstructions;
